// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"936fbf75","136":"c27933d5","217":"43b42a74","277":"596219e3","369":"43428fac","371":"9c6f18b1","453":"76e8fa0a","538":"8eaf4e88","590":"52ab1ab5","711":"53d5deb2","715":"1f90606c","896":"61fe6858"}[chunkId] + ".chunk.js";
};